import graphqlClient from '~/graphql/graphqlClient';
import type {
  MutationNewsletterUnsubscribeArgs,
  NewsletterUnsubscribeResult,
} from 'dt-common/generated/graphql-types';

const mutation = `
mutation NewsletterUnsubscribe(
  $playerId: String!
  $email: String
) {
  newsletterUnsubscribe(
    playerId: $playerId
    email: $email
  ) {
    ok
    detail
  }
}
`;

export default async function mutationNewsletterUnsubscribe(
  args: MutationNewsletterUnsubscribeArgs
): Promise<NewsletterUnsubscribeResult> {
  return await graphqlClient.request<NewsletterUnsubscribeResult>(
    'newsletterUnsubscribe',
    mutation,
    args
  );
}

